import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://www.monferratoway.com";

export const Seo = ({ title, description, locale }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    const set = (sel, attr, val) => {
      const el = document.head.querySelector(sel);
      if (el) el.setAttribute(attr, val);
    };
    const pathSlash = pathname === "/" ? "/" : `${pathname.replace(/\/$/, "")}/`;
    const url = `${BASE}${pathSlash}`;
    document.documentElement.lang = (locale || "en").split(/[_-]/)[0];
    set('meta[name="description"]', "content", description);
    set('link[rel="canonical"]', "href", url);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:url"]', "content", url);
    if (locale) set('meta[property="og:locale"]', "content", locale);

    // hreflang alternates: / = en (default), /ru = ru
    document.head.querySelectorAll("link[data-hreflang]").forEach((el) => el.remove());
    const basePath = pathname.replace(/^\/ru/, "") || "/";
    const baseSlash = basePath === "/" ? "/" : `${basePath.replace(/\/$/, "")}/`;
    const enUrl = `${BASE}${baseSlash}`;
    const ruUrl = `${BASE}${baseSlash === "/" ? "/ru/" : `/ru${baseSlash}`}`;
    [
      ["en", enUrl],
      ["ru", ruUrl],
      ["x-default", enUrl],
    ].forEach(([hl, href]) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = hl;
      link.href = href;
      link.setAttribute("data-hreflang", "1");
      document.head.appendChild(link);
    });
  }, [title, description, locale, pathname]);
  return null;
};
